import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
} from "@mui/icons-material";
import {
    Alert,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { useEffect, useState } from "react";
import {
    getAllUsers,
    reset,
    UsersSearch,
} from "../../Redux/UserSlice/UserSlice";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const AllUsers = () => {
    const dispatch = useDispatch();
    const { parent } = useParams();
    const { users, isLodaing } = useSelector((state) => state.users);
    
    const UserTable = users?.data?.data || [];
    const UserPagination = users?.data || [];

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Filter By Fields Variables
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [ppw, setPPW] = useState("");
    const [business, setBusiness] = useState("");
    const [solutions, setSolutions] = useState("");
    const [contracts, setContracts] = useState("");
    const [is_active, setActive] = useState("");

    const searchObj = {
        name,
        email,
        ppw,
        business,
        solutions,
        contracts,
        is_active,
    };

    const handelFilterAction = async (search_object = null) => {
        await dispatch(
            UsersSearch({
                parent: parent,
                ...search_object,
                paginate: rowsPerPage,
            })
        );
        await dispatch(reset());
    };

    const handelResetData = () => {
        setName("");
        setEmail("");
        setPPW("");
        setBusiness("");
        setSolutions("");
        setContracts("");
        setActive("");
        handelFilterAction();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                UsersSearch({
                    parent: parent,
                    ...searchObj,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                UsersSearch({ ...searchObj, paginate: event.target.value })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    function inputKeyUp(e) {
        e.which = e.which || e.keyCode;
        if (e.which === 13) {
            handelFilterAction(searchObj);
        }
    }

    useEffect(() => {
        const GetAllUsers = async () => {
            if (parent) await dispatch(getAllUsers({ parent: parent }));
            else await dispatch(getAllUsers());
            await dispatch(reset());
        };
        GetAllUsers();
    }, [dispatch, parent]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            name="name"
                                            label="Name"
                                            value={name}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="email"
                                            name="email"
                                            label="Email"
                                            value={email}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setEmail(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="ppw"
                                            name="ppw"
                                            type="number"
                                            step="0.01"
                                            label="PPW"
                                            value={ppw}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setPPW(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="business"
                                            name="business"
                                            label="Business"
                                            value={business}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setBusiness(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="solutions"
                                            name="solutions"
                                            label="Solutions"
                                            value={solutions}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setSolutions(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="contracts"
                                            name="contracts"
                                            label="Contracts"
                                            value={contracts}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setContracts(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            id="childrens"
                                            name="childrens"
                                            label="Childrens"
                                            // value={childrens}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setContracts(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Active
                                            </InputLabel>
                                            <Select
                                                id="is_active"
                                                name="is_active"
                                                label="Active"
                                                value={is_active}
                                                onChange={(e) =>
                                                    setActive(e.target.value)
                                                }
                                            >
                                                <MenuItem value="2">
                                                    Inactive
                                                </MenuItem>
                                                <MenuItem value="1">
                                                    Active
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </TableCell>

                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Name </TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>PPW</TableCell>
                                <TableCell>Business</TableCell>
                                <TableCell>Solutions</TableCell>
                                <TableCell>Contracts</TableCell>
                                <TableCell align="center">Childrens</TableCell>
                                <TableCell align="center">Active</TableCell>
                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {UserTable.map((key, index) => (
                                <TableRowStyled key={Math.random()}>
                                    <TableCellStyle>
                                        {rowsPerPage * page + index + 1}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.name}</TableCellStyle>
                                    <TableCellStyle>{key.email}</TableCellStyle>
                                    {/* <TableCellStyle>{key.address}</TableCellStyle> */}
                                    <TableCellStyle>{key.ppw}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.business}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.opportunities_count !== 0 ? (
                                            <Link
                                                to={
                                                    "/dashboard/solutions/user=" +
                                                    key.id
                                                }
                                            >
                                                {key.opportunities_count}
                                            </Link>
                                        ) : (
                                            key.opportunities_count
                                        )}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key.solar_contracts_count !== 0 ? (
                                            <Link
                                                to={
                                                    "/dashboard/solar-contracts/user=" +
                                                    key.id
                                                }
                                            >
                                                {key.solar_contracts_count}
                                            </Link>
                                        ) : (
                                            key.solar_contracts_count
                                        )}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {key?.childrens_count === 0 ? (
                                            <>{key?.childrens_count}</>
                                        ) : (
                                            <>
                                                <Link
                                                    to={
                                                        `/dashboard/users/` +
                                                        key.id +
                                                        `/childrens`
                                                    }
                                                >
                                                    {key?.childrens_count}
                                                </Link>
                                            </>
                                        )}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        {key.is_active ? (
                                            <CheckCircleOutline color="success" />
                                        ) : (
                                            <DoDisturbOn />
                                        )}
                                    </TableCellStyle>

                                    <TableCellStyle align="center">
                                        <IconButton>
                                            <Link to={"edit=" + key.id}>
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                        {/* <IconButton>
											<ProgressStyled>
												<CircularProgress size={30} color="error" />
											</ProgressStyled>

											<ProgressStyled>
												<Delete color="error" />
											</ProgressStyled>
											</IconButton> */}
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                        <TableHeadStyled>
                            <TableRow>
                                {UserPagination.total >= 20 && (
                                    <TablePagination
                                        rowsPerPageOptions={[
                                            20,
                                            50,
                                            100,
                                            { label: "All", value: -1 },
                                        ]}
                                        colSpan={12}
                                        count={UserPagination.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </TableRow>
                        </TableHeadStyled>
                    </Table>

                    {UserPagination.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllUsers;
